/* ============================================
   GLASS HEADER — Comfrt-style scroll behavior
   Replaces Dawn's StickyHeader with fixed glass
   ============================================ */
(function() {
  'use strict';

  var sectionHeader = document.querySelector('.section-header');
  if (!sectionHeader) return;

  /* --- Body offset calculation --- */
  function updateHeaderOffset() {
    var annoBar = document.querySelector('.shopify-section-announcement-bar');
    var annoHeight = annoBar ? annoBar.offsetHeight : 0;
    var headerHeight = sectionHeader.offsetHeight;
    var total = annoHeight + headerHeight;
    document.documentElement.style.setProperty('--glass-header-total-height', total + 'px');
    document.body.style.paddingTop = total + 'px';
  }

  /* --- Comfrt-style scroll: hide on scroll down, reveal on scroll up --- */
  var lastScrollY = 0;
  var ticking = false;
  var isHidden = false;
  var scrollThreshold = 80;

  function glassScroll() {
    var currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
    var headerHeight = sectionHeader.offsetHeight;

    if (currentScrollY <= 5) {
      /* At top — full reset */
      sectionHeader.style.setProperty('top', '0px', 'important');
      sectionHeader.classList.remove('glass-header--hidden', 'glass-header--sticky');
      isHidden = false;
    } else if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
      /* Scrolling DOWN — hide header */
      if (!isHidden) {
        sectionHeader.style.setProperty('top', '-' + (headerHeight + 10) + 'px', 'important');
        sectionHeader.classList.add('glass-header--hidden');
        sectionHeader.classList.remove('glass-header--sticky');
        isHidden = true;
      }
    } else if (currentScrollY < lastScrollY) {
      /* Scrolling UP — reveal header */
      if (isHidden) {
        sectionHeader.style.setProperty('top', '0px', 'important');
        sectionHeader.classList.remove('glass-header--hidden');
        sectionHeader.classList.add('glass-header--sticky');
        isHidden = false;
      }
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(glassScroll);
      ticking = true;
    }
  }

  /* --- Disable Dawn's built-in StickyHeader completely --- */
  function disableDawnSticky() {
    var stickyEl = document.querySelector('sticky-header');
    if (!stickyEl) return;

    /* Remove Dawn's scroll listener */
    if (stickyEl.onScrollHandler) {
      window.removeEventListener('scroll', stickyEl.onScrollHandler, false);
    }

    /* Override the methods so they do nothing */
    stickyEl.hide = function() {};
    stickyEl.reveal = function() {};
    stickyEl.reset = function() {};
    stickyEl.onScroll = function() {};

    /* Clean up any Dawn classes already applied */
    sectionHeader.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate',
      'scrolled-past-header'
    );
  }

  /* --- Init --- */
  function init() {
    updateHeaderOffset();

    /* Wait a tick for Dawn's custom element to fully register */
    setTimeout(function() {
      disableDawnSticky();
      window.addEventListener('scroll', onScroll, { passive: true });
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-calc on resize */
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateHeaderOffset, 100);
  });

  /* Re-calc after fonts load */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderOffset);
  }

  /* Re-calc periodically for first 3 seconds */
  var checks = 0;
  var interval = setInterval(function() {
    updateHeaderOffset();
    checks++;
    if (checks >= 6) clearInterval(interval);
  }, 500);
})();
